import React, { Component } from 'react';
import FbrService from '../service/FbrService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'moment/locale/fr';
import moment from 'moment';
 
export class FormStatRapportagePrestMois extends Component {
    constructor() {
        super();
        this.state = {
            rannee: moment(new Date()).format('YYYY'),
            rRegion: null,
            rPref: null,
            rCrd: null,
            liste_data: [],
            liste_region: [],
            liste_all_pref: [],
            liste_pref: [],
            liste_all_crd: [],
            liste_crd: [],
            items: [
                {
                    label: 'Format CSV',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.dt.exportCSV();
                    }
                }
            ],
            showindicator: false,
            userconnected: JSON.parse(localStorage.getItem('userconnected')),
        };
        this.conf_print = this.conf_print.bind(this);
        this.FbrService = new FbrService();
    }


    conf_print(format) {
        let spd1 = moment(this.state.pd1).format('MM/YYYY');
        let spd2 = moment(this.state.pd2).format('MM/YYYY');
        let region = 'Tous';
        let pref = 'Tous';
        let crd = 'Tous';
        if (this.state.rCrd !== undefined && this.state.rCrd !== null) {
            crd = this.state.rCrd;
        }
        if (this.state.rRegion !== undefined && this.state.rRegion !== null) {
            region = this.state.rRegion;
        }
        if (this.state.rPref !== undefined && this.state.rPref !== null) {
            pref = this.state.rPref;
        }
        this.FbrService.generer_stat_rapportage_prest(spd1, spd2, region, pref,crd, format);
    }

    get_liste_data() {
        let region = 'Tous';
        let pref = 'Tous';
        let crd = 'Tous';
        if (this.state.rCrd !== undefined && this.state.rCrd !== null) {
            crd = this.state.rCrd;
        }
        if (this.state.rRegion !== undefined && this.state.rRegion !== null) {
            region = this.state.rRegion;
        }
        if (this.state.rPref !== undefined && this.state.rPref !== null) {
            pref = this.state.rPref;
        }
        this.setState({showindicator: true});
        this.FbrService.get_stat_rapportage_mois_prest(this.state.rannee, region, pref,crd).then(data => this.setState({ liste_data: data,showindicator: false }));
    }

    componentDidMount() {
        this.FbrService.get_liste_prefecture().then(data => {
			if (data != null && data != undefined) {
                this.setState({liste_all_pref: data});
			} 
		});
        this.FbrService.get_liste_crd().then(data => {
			if (data != null && data != undefined) {
                this.setState({ liste_all_crd: data });
			} 
		});
        this.get_liste_data();
        this.setState({liste_region: this.FbrService.get_liste_regions()});
    }


    select_pref(region) {
        let liste = [];
        if (this.state.liste_all_pref != null && this.state.liste_all_pref != undefined) {
            if (this.state.liste_all_pref.length > 0) {
                let liste_filtre = this.state.liste_all_pref.filter(function (el) {
                    return el.region == region;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_pref, label: x.nom_pref }
                        });
                    }
                }
            }
        }
        this.setState({ liste_pref: liste });
    }

    select_crd(pref) {
        let liste = [];
        if (this.state.liste_all_crd != null && this.state.liste_all_crd != undefined) {
            if (this.state.liste_all_crd.length > 0) {
                let liste_filtre = this.state.liste_all_crd.filter(function (el) {
                    return el.nom_pref == pref;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_crd, label: x.nom_crd }
                        });
                    }
                }
            }
        }
        this.setState({ liste_crd: liste });
    }


    render() {
        return (
            <div className="card p-fluid">
                <div className="grid">
                    <div className="col-12">
                        <div className="card-w-title">
                            <i className="pi pi-search"></i> Option de recherche
                                    <hr />
                            <div className="grid">
                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'IRS', value: 'Tous' }].concat(this.state.liste_region)} optionLabel='label' placeholder='IRS' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rRegion} onChange={e => this.setState({ rRegion: e.value }, () => {
                                        //this.get_liste_data();
                                        this.select_pref(e.value);
                                    })} />
                                </div>
                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'DPS', value: 'Tous' }].concat(this.state.liste_pref)} optionLabel='label' placeholder='DPS' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rPref} onChange={e => this.setState({ rPref: e.value }, () => {
                                       // this.get_liste_data();
                                        this.setState({liste_crd: []});
                                        this.select_crd(e.value);
                                    })} />
                                </div>
                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'CR', value: 'Tous' }].concat(this.state.liste_crd)} optionLabel='label' placeholder='CR' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rCrd} onChange={e => this.setState({ rCrd: e.value }, () => {
                                       // this.get_liste_data();
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <SplitButton label="Rechercher" style={{ width: '140px' }} onClick={(e) => this.get_liste_data()} icon="pi pi-search" model={this.state.items}></SplitButton>
                                </div>
                                <div className="col-12 md:col-1">
                                        {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable value={this.state.liste_data} responsive={true} paginator={true} rows={20} paginatorPosition="top" alwaysShowPaginator={false}  csvSeparator=";" ref={(el) => { this.dt = el; }} className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers" >
                    <Column field="ordre" header="#" style={{ width: '5%' }} filter={true} filterMatchMode='contains' />
                    <Column field="nomPrest" header="Acteur" filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="regionSite" header="IRS" filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} />
                    <Column field="prefectureSite" header="DPS" filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} />

                    <Column field="rp_1" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_1=='Oui'?"1":"0"} severity={rowData.rp_1=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Jan" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_2" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_2=='Oui'?"1":"0"} severity={rowData.rp_2=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Fev" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_3" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_3=='Oui'?"1":"0"} severity={rowData.rp_3=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Mars" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_4" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_4=='Oui'?"1":"0"} severity={rowData.rp_4=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Avr" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_5" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_5=='Oui'?"1":"0"} severity={rowData.rp_5=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Mai" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_6" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_6=='Oui'?"1":"0"} severity={rowData.rp_6=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Jun" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_7" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_7=='Oui'?"1":"0"} severity={rowData.rp_7=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Jul" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_8" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_8=='Oui'?"1":"0"} severity={rowData.rp_8=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Aout" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_9" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_9=='Oui'?"1":"0"} severity={rowData.rp_9=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Sep" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />
                    <Column field="rp_10" body={(rowData, column) => {
                        return <div>
                            <Badge value={rowData.rp_10=='Oui'?"1":"0"} severity={rowData.rp_10=='Oui'?"success":"warning"}/>
                        </div>
                    }}  header="Oct" filter={true} filterMatchMode='contains' style={{ width: '5%' }} />

                </DataTable>
            </div>
        );
    }
}